import React from 'react';
import { mockData } from '../mock';

const MotivationMarquee = () => {
  return (
    <section className="bg-gradient-to-r from-electric-blue to-neon-green py-8 overflow-hidden">
      <div className="whitespace-nowrap">
        <div className="inline-block animate-marquee">
          <span className="text-4xl md:text-6xl font-black text-white uppercase tracking-wider">
            {mockData.motivationMarquee.map((word, index) => (
              <span key={index} className="mx-16">
                {word}
                <span className="mx-8 text-white/50">·</span>
              </span>
            ))}
            {/* Duplicate for seamless scroll */}
            {mockData.motivationMarquee.map((word, index) => (
              <span key={`dup-${index}`} className="mx-16">
                {word}
                <span className="mx-8 text-white/50">·</span>
              </span>
            ))}
          </span>
        </div>
      </div>
    </section>
  );
};

export default MotivationMarquee;